export default function ipValidator(str) {
    const [ipStr, mask] = str.split('/');

    // mask is optional number from 10 to 32
    // prevent allocation of big chunks of internet
    if (mask !== undefined) {
        if ((mask < 10) || (mask > 32)) {
            return false;
        }
    }

    const ipParts = ipStr.split('.');
    return (ipParts.length === 4)
        && ipParts.every((ip) => (ip >= 0) && (ip < 256));
}
